<template>
	<div>
		<StorehouseAddNew :isSidebarActiveStorehouse="addNewDataSidebar" @closeSidebar="toggleDataSidebar"
			:data="sidebarData" />
		<DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
		<StorehouseDetailAddNew :isPromptActiveStorehouseDetail="addNewDataSidebarStorehouseDetail" :data="infoData" />
		<CargoAddNew :isPromptCargoActive="addNewCargoPromptValid" :data="sidebarData" />
		<vs-card>
			<b-row class="justify-content-md-start" v-if="!isMobile()">
				<b-col cols="3">
					<b-form-group label-for="item-name">
						<b-form-input v-model="searchedVal" id="smallInput" :placeholder="$t('Search')"
							@keyup.enter="filterStorehouseList" size="sm" />
					</b-form-group>
				</b-col>
				<b-col cols="12" md="auto" style="padding-left: 0px !important;">
					<b-button class="bg-primary" style=" border-color:white;" size="sm" v-on:click="filterStorehouseList()">
						<Icon icon="material-symbols:search-rounded" width="20" height="20" />
					</b-button></b-col>
				<b-col cols="12" md="auto" style="padding-left: 0px !important;">
					<success-btn :bgcolor="'bg-success'" :title="'AddNew'" :icon="'mingcute:add-line'" :size="'sm'" /></b-col>
			</b-row>
			<b-row class="justify-content-md-start" v-else>
				<b-col cols="6">
					<b-form-group label-for="item-name">
						<b-form-input v-model="searchedVal" id="smallInput" :placeholder="$t('Search')"
							@keyup.enter="filterStorehouseList" size="sm" />
					</b-form-group>
				</b-col>
				<b-col cols="2" style="padding-left: 0px !important;">
					<b-button class="bg-primary" style=" border-color:white;" size="sm" v-on:click="filterStorehouseList()">
						<Icon icon="material-symbols:search-rounded" width="20" height="20" />
					</b-button></b-col>
				<b-col cols="4" style="padding-left: 0px !important;">
					<success-btn :bgcolor="'bg-success'" :title="'AddNew'" :icon="'mingcute:add-line'" :size="'sm'" /></b-col>
			</b-row>
			<ag-grid-vue ref="agGridTable" class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
				:columnDefs="storehouseColumns" :defaultColDef="defaultColDef" :rowData="storehouseList" rowSelection="multiple"
				colResizeDefault="shift" :animateRows="true" :pagination="true" @grid-ready="onGridReady"
				:suppressCopyRowsToClipboard="true" :suppressPaginationPanel="true" :localeText="localeText">
			</ag-grid-vue>
		</vs-card>
	</div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import moment from "moment";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import SuccessBtn from '../../components/vx-button/SuccessBtn.vue'
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import StorehouseAddNew from "./StorehouseAddNew.vue"
import StorehouseDetailAddNew from "./StorehouseDetailAddNew.vue"
import updateDeleteInfoBtnCellRenderer from "../CellRenderers/updateDeleteInfoBtnCellRenderer.vue"
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import CustomerInfoValCellRenderer from "./CellRenderers/CustomerInfoValCellRenderer.vue"
import statusShowCellRenderer from "../CellRenderers/statusShowCellRenderer.vue"
import i18nData from "../../i18n/i18nData"
import CargoAddNew from "./CargoAddNew.vue";
export default {
	data() {
		return {
			addNewCargoPromptValid: false,
			ROLE: this.$store.state.AppActiveUser.ROLE,
			storehouseListFiltered: [],
			isMobile: function () {
				return isMobile;
			},
			infoData: [],
			sidebarData: [],
			deleteWarningPromptValid: false,
			deleteData: [],
			addNewDataSidebarStorehouseDetail: false,
			addNewDataSidebar: false, searchedVal: "", storehouseList: [], storehouseColumns: [], defaultColDef: {
				sortable: true,
				editable: true,
				resizable: true
			},
			customerInfoList: []
		}
	},
	components: { CargoAddNew, detailBtnCellRenderer, statusShowCellRenderer, StorehouseDetailAddNew, CustomerInfoValCellRenderer, DeleteWarning, updateDeleteInfoBtnCellRenderer, StorehouseAddNew, SuccessBtn, Icon, AgGridVue },
	methods: {
		closeCargoData() {
			this.addNewCargoPromptValid = false
		},
		filterStorehouseList() {
			this.storehouseList = this.storehouseListFiltered;
			this.storehouseList = this.storehouseList.filter(post => {
				return post.DepotName.toUpperCase().includes(this.searchedVal.toUpperCase()) || post.DepotNo.toUpperCase().includes(this.searchedVal.toUpperCase());
			});
		},
		addInfoDataStorehouse(data) {
			this.infoData = data;
			this.addNewDataSidebarStorehouseDetail = true
		},
		deleteSubmit(data) {
			const vs = this.$vs;
			this.$store
				.dispatch("storehouse/deleteStorehouse", data.DepotId)
				.then(response => {
					if (response.status == 200) {
						try {
							vs.notify({
								text: response.data.message,
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "success",
								position: "top-center"
							});
							this.getStorehouseList();
							this.deleteWarningPromptValid = false;
						} catch (error) {
							console.log(error);
						}
					} else
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
				})
				.catch(error => {
					console.log(error);
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});


		},
		closeDeleteWarning() {
			this.deleteWarningPromptValid = false
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val
		},
		addNewData() {
			this.sidebarData = {}
			this.toggleDataSidebar(true)
		},
		onGridReady(params) {
			this.gridApi = params.api;
			this.gridColumnApi = params.columnApi;
			var defaultSortModel = [
				{ colId: 'DepotNo', sort: 'asc', sortIndex: 0 },
			];
			params.columnApi.applyColumnState({ state: defaultSortModel });
			this.gridApi.refreshCells(params);
		},
		updateStorehouse(data) {
			this.sidebarData = data;
			this.toggleDataSidebar(true)
		},

		deleteStorehouse() {
			this.deleteWarningPromptValid = true;
		},
		parseDate(params) {
			return moment(String(params)).format("DD.MM.YYYY");
		},
		closeInfoDataStorehouse() {
			this.addNewDataSidebarStorehouseDetail = false
		},
		addCargo(data) {
			this.sidebarData = data;
			this.addNewCargoPromptValid = true
		},
		getStorehouseList() {
			console.log(this.storehouseForCompany)
			console.log(this.ROLE)
			const vs = this.$vs;
			this.storehouseList = [];
			this.storehouseColumns = [];


			this.storehouseList = this.storehouse;
			this.storehouseListFiltered = this.storehouse;
			if (this.ROLE == "Company") {
				this.storehouseList = this.storehouseForCompany;
				this.storehouseListFiltered = this.storehouseForCompany;
			}
			if (this.storehouseList.length > 0) {
				let columnList = Object.keys(this.storehouseList[0]);
				this.storehouseColumns.push({
					width: 150,
					pinned: "left",
					cellRendererFramework: "updateDeleteInfoBtnCellRenderer",
					cellRendererParams: {
						addMethods: "addInfoDataStorehouse",
						addIcon: "icon-park-outline:view-grid-detail"
					}
				},)
				if (this.ROLE != "Company")
					this.storehouseColumns.push({
						headerName: this.$t('addCargo'),
						width: 80,
						pinned: "left",
						cellRendererFramework: "detailBtnCellRenderer",
						cellRendererParams: {
							detailMethods: "addCargo",
							iconDetail: "jam:store",
							iconColor: "#17c3b2"
						}
					},)
				columnList.forEach((val, index) => {
					if (val == "DepotName" || val == "DepotNo" || val == "CompanyName" || val == "CompanyInfoName") {
						if (this.isMobile()) this.storehouseColumns.push({ width: 150, headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });
						else this.storehouseColumns.push({ width: 150, headerName: this.$t(val), pinned: "left", field: val, filter: "agSetColumnFilter" });
					}
					else if (val == "Status")
						this.storehouseColumns.push({ width: 80, headerName: this.$t(val), cellRendererFramework: "statusShowCellRenderer", field: val, filter: "agSetColumnFilter" });
					else if (val != "DepotId" && val != "DepotType" && val != "CompanyId" && val != "CompanyInfoId" && val != "DepotGroupId" && val.toString().includes("Date") == false)
						this.storehouseColumns.push({ headerName: this.$t(val), field: val, filter: "agSetColumnFilter" });
					else if (val.toString().includes("Date") == true) {
						this.storehouseColumns.push({ headerName: this.$t(val), field: val, filter: "agSetColumnFilter", valueFormatter: params => this.parseDate(params.data[val]) });
					}
				});
			}
		},
	},
	computed: {
		storehouse: {
			get() {
				return this.$store.state.storehouse.Storehouse
			},
			set(val) {
				if (!val) {

				}
			}
		},
		storehouseForCompany: {
			get() {
				return this.$store.state.storehouse.StorehouseForCompany
			},
			set(val) {
				if (!val) {

				}
			}

		},
		localeText() {
			return i18nData[this.$i18n.locale];
		},
	}, created() {
		this.getStorehouseList();
	},
	mounted() {
		//tables global olarak tanımlanıyor
		this.$root.$on("closeInfoDataStorehouse", () => {
			this.closeInfoDataStorehouse();
		});
		this.$root.$on("addInfoDataStorehouse", (infoData) => {
			this.addInfoDataStorehouse(infoData);
		});
		this.$root.$on("addNewData", () => {
			this.addNewData();
		});
		this.$root.$on("editData", (data) => {
			this.updateStorehouse(data);
		});
		this.$root.$on("deleteData", (data) => {
			this.deleteData = data
			this.deleteStorehouse(data);
		});
		this.$root.$on("closeDeleteWarning", () => {
			this.closeDeleteWarning();
		});
		this.$root.$on("deleteSubmit", (data) => {

			this.deleteSubmit(data);
		});
		this.$root.$on("getStorehouseList", (data) => {
			this.getStorehouseList(data);
		});
		this.$root.$on("addCargo", (data) => {
			this.addCargo(data);
		});
		this.$root.$on("closeCargoData", (data) => {
			this.closeCargoData(data);
		});
	},
	beforeDestroy() {
		this.$root.$off("addInfoDataStorehouse");
		this.$root.$off("closeInfoDataStorehouse");
		this.$root.$off("addNewData");
		this.$root.$off("editData");
		this.$root.$off("editData");
		this.$root.$off("closeDeleteWarning");
		this.$root.$off("deleteSubmit");
		this.$root.$off("getStorehouseList");
		this.$root.$off("addCargo");
		this.$root.$off("closeCargoData");
	},
}
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
	// height: calc(var(--vh, 1vh) * 100 - 4.3rem);
	height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

	&:not(.ps) {
		overflow-y: auto;
	}
}
</style>